<template>
  <div class="container">
    <div class="survey-list" v-if="fetchedSurveys.length">
      <ul class="survey">
        <li class="" v-for="survey in fetchedSurveys" @click="changeSurveyView(survey)">
          <div class="survey01">
            {{ survey.surveyName }}
          </div>
          <span v-if="survey.surveyBenefits.length > 1">
            {{ survey.surveyBenefits[0].benefitType }} {{ survey.surveyBenefits.length }}개 지급
          </span>
          <span v-else-if="survey.surveyBenefits.length === 1">
            {{ survey.surveyBenefits[0].benefitType }} 지급
          </span>
          <span class="survey02">
            ~ {{ survey.surveyEndDt }}
          </span>
        </li>
      </ul>
    </div>
    <div v-else>
      <EmptyMessage v-if="fetchedSurveyAnswerYn === YN.N" message="현재 진행중인 설문조사가 없습니다." paddingTop="20%"/>
      <EmptyMessage v-else message="참여한 설문조사가 없습니다." paddingTop="20%"/>
    </div>
  </div>
</template>

<script>
import EmptyMessage from "@/components/common/EmptyMessage.vue";
import {mapActions, mapGetters} from "vuex";
import {YN} from "../AppConstants";

export default {
  components: {EmptyMessage},
  computed: {
    ...mapGetters(['fetchedSurveys', 'fetchedSurveyAnswerYn']),
    YN() {
      return YN;
    }
  },
  created() {
    // 파라미터 설정
    const params = {
      answerYn: this.fetchedSurveyAnswerYn === YN.N ? YN.N : YN.Y
    }

    // 설문조사 목록 조회
    this.showLoading(true);
    this.FETCH_SURVEYS(params)
      .then(response => {
        if (response.code !== '0000') {
          this.showAlert(response.message);
        }
      })
      .catch(error => this.showAlert("설문조사 리스트 조회에 실패했습니다."))
      .finally(() => this.showLoading(false))
  },
  methods: {
    ...mapActions(['FETCH_SURVEYS']),
    changeSurveyView(survey) {
      // 설문조사 상세 이동
      if (survey.answerYn === YN.N) {
        this.$router.push({path: `/survey/${survey.surveyId}`, query: {surveyMemberId: survey.surveyMemberId}})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/survey/SurveyList.vue